<div class="d-flex flex-column payment-status-container gap-4">
  <div class="payment-detail-container gap-4 d-flex flex-column">
    <button (click)="onClick()" class="btn btn-primary home-btn" type="button">
      <i class="fa-solid fa-house me-2"></i>Home
    </button>
    <app-pac-detail [pacDetails]="pacDetails"></app-pac-detail>
  </div>

  <ng-container>
    <div class="payment-status-section p-3 gap-3 d-flex flex-column">
      <span class="payment-status-heading">
        {{ isAborted ? 'Payment process not completed. Total amount payable is partially paid.' : 'Payment Made.' }}
      </span>
      <span *ngIf="pacDetails?.paidLineItems?.length === 0" class="payment-status-heading">
        {{ 'No Payments Detected To Generate a Receipt'}}
      </span>
      <span *ngIf="isPayNowUnrecorded()"  class="payment-status-heading">
        {{ 'PayNow payment is pending confirmation.'}}
      </span>

      <div class="collection-details" *ngIf="pacDetails?.paidLineItems as paidItems">
        <div class="d-flex flex-column gap-3">
          <span class="collection-details-heading col-6">Collection Details:</span>
          <div class="table-responsive d-none d-sm-block">
            <table class="table" aria-label="Collection Details">
              <thead>
              <tr>
                <th *ngIf="hasTransactionReference()" scope="col">Transaction Reference</th>
                <th scope="col">Payment Method</th>
                <th scope="col">Payment Date & Time</th>
                <th scope="col">Amount</th>
                <th scope="col">Receipt Number</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let item of paidItems">
                <tr>
                  <td *ngIf="hasTransactionReference()">{{ item.transactionId }}</td>
                  <td>{{ getPaymentMode(item.paymentMode) }}</td>
                  <td>{{ (item.collectionDate || today) | date: 'dd-MM-yyyy HH:mm'}}</td>
                  <td>{{showAmountFormatted(item.paymentAmount)}}</td>
                  <td>{{ item.receiptNumber }} </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>

          <div class="table-mobile-container d-flex flex-column gap-2 d-block d-sm-none">
            <ng-container *ngFor="let item of paidItems">
              <div class="row-mobile d-flex align-items-center">
                <div class="info-container d-flex flex-column gap-1">
                  <span *ngIf="hasTransactionReference()" class="reference">{{ item.transactionId }}</span>
                  <span class="method">{{ getPaymentMode(item.paymentMode) }}</span>
                  <span class="method">{{ (item.collectionDate || today) | date: 'dd-MM-yyyy HH:mm'}}</span>
                  <span class="method">{{ item.receiptNumber }}</span>
                </div>
                <span class="amount">$ {{ item.paymentAmount?.toFixed(2) || '0.00' }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="hasTransactionReference()" class="d-flex flex-column flex-sm-row email-and-pdf-section gap-3">
        <div class="d-flex ps-2 email-container gap-2 align-items-center flex-fill">
          <label for="emailAddress" class="visually-hidden">Email Address</label>
          <input
            id="emailAddress"
            [(ngModel)]="emailAddress"
            class="form-control vkeyboard"
            placeholder="Please enter email address"
            spellcheck="false"
            type="email"
          />
          <button
            (click)="sendEmailReceipt()"
            [disabled]="!emailAddress"
            class="btn btn-secondary"
            type="button"
          >
            <i class="fa-regular fa-envelope me-2"></i>
            Email Receipt
          </button>
        </div>

        <button
          (click)="downloadReceipts()"
          [disabled]="!allowDownloads"
          class="btn btn-primary"
          type="button"
        >
          <i class="fa-regular fa-file-pdf me-2"></i>Save Receipt as PDF
        </button>
      </div>

    </div>
  </ng-container>
</div>

<app-custom-modal
  #emailConfirmationModalRef
  (onCloseModel)="handleEmailConfirmationClose($event)"
  [confirmButtonText]="'Ok'"
  [message]="confirmationMessage"
  [modalId]="'emailConfirmationModal'"
  [showConfirmOnly]="true"
  [title]="'Email Receipt'">
</app-custom-modal>

<app-custom-modal
  #leaveWithoutReceiptModalRef
  [modalId]="'leaveWithoutReceiptModel'"
  [title]="'Confirmation'"
  [message]="leaveWithoutReceiptMessage"
  [confirmButtonText]="'Yes'"
  [cancelButtonText]="'No'"
  [showConfirmOnly]="false"
  (onCloseModel)="handleLeaveWithoutReceiptClose($event)">
</app-custom-modal>


<app-virtual-keyboard></app-virtual-keyboard>

